/**
 * MOCK DATA — Blog público
 * Sección: Blog (/blog, /blog/:id)
 * Reemplazar por: consultas a Supabase (artículos, historias de líderes)
 */
export const mockBlogPosts = [
  {
    id: 'b1',
    type: 'article',
    title: '5 Hábitos Financieros para Proteger tu Patrimonio en 2024',
    excerpt: 'La inflación no perdona, pero la educación financiera es tu mejor escudo. Descubre cómo los líderes de GFI están asesorando a sus clientes este año.',
    content: `
      <p>El panorama económico mundial cambia constantemente, y la comunidad latina a menudo es la más vulnerable ante la falta de información estratégica. En GFI Latino, creemos que la educación es el primer paso hacia la libertad.</p>
      <h3>1. Págate a ti mismo primero</h3>
      <p>Antes de pagar facturas o deudas, separa un porcentaje de tus ingresos para ahorro e inversión. Este simple cambio de mentalidad garantiza que estás construyendo tu futuro, no solo pagando por tu pasado.</p>
      <h3>2. Comprende el Interés Compuesto</h3>
      <p>Albert Einstein lo llamó la octava maravilla del mundo. Quien lo entiende, lo gana; quien no, lo paga. Asegúrate de que tu dinero esté trabajando en vehículos que capitalicen el interés a tu favor.</p>
      <h3>3. Protege tu activo más importante: Tú</h3>
      <p>Muchos aseguran sus autos y sus casas, pero dejan su capacidad de generar ingresos desprotegida. Los seguros de vida con beneficios en vida son una herramienta fundamental que todo perfil financiero debe considerar.</p>
      <p><em>La educación financiera no es un destino, es un viaje continuo. Mantente conectado con tu agente de GFI para trazar un mapa adaptado a tu realidad.</em></p>
    `,
    author: 'María González',
    date: '15 Mar 2024',
    image: 'https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
    category: 'Educación Financiera'
  },
  {
    id: 'b2',
    type: 'leader',
    title: 'De Inmigrante a Director de Agencia',
    excerpt: 'La historia de Carlos Rodríguez nos recuerda que el sueño americano se construye con educación, disciplina y una comunidad fuerte.',
    content: `
      <p>Llegué a este país hace 15 años con una maleta llena de sueños y muy poco entendimiento de cómo funcionaba el sistema financiero aquí. Cometí todos los errores que enseño a mis clientes a evitar: tarjetas de crédito al límite, cero ahorros y la creencia de que un seguro de vida era solo para cuando uno fallece.</p>
      <p>Mi punto de inflexión llegó cuando conocí la misión de GFI. No me ofrecieron un producto, me ofrecieron educación. Me mostraron un pizarrón en blanco y me explicaron la regla del 72.</p>
      <p>Ese día decidí que no solo iba a arreglar mis finanzas, sino que iba a dedicar mi vida a que ninguna otra familia latina pasara por la ignorancia financiera que yo experimenté.</p>
      <p>Hoy, como Director de Agencia, mi mayor orgullo no son los números de producción, sino ver a los agentes de mi equipo convertirse en líderes comunitarios. Ver a una familia recibir las llaves de su primera casa porque les ayudamos a estructurar su ahorro, o entregar un cheque de beneficios en vida que salva a una familia de la bancarrota durante una enfermedad... eso es lo que me levanta de la cama cada mañana.</p>
      <p>El liderazgo no es un título, es una responsabilidad. Y en GFI Latino, apenas estamos comenzando.</p>
    `,
    author: 'Carlos Rodríguez',
    role: 'Director de Agencia',
    quote: '"El éxito no se mide por cuánto dinero haces, sino por a cuántas familias proteges y educas en el camino."',
    date: '10 Mar 2024',
    image: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    category: 'Historia de Líder'
  },
  {
    id: 'b3',
    type: 'article',
    title: 'El Impacto del Seguro de Vida con Beneficios en Vida',
    excerpt: 'Ya no necesitas fallecer para usar tu seguro. Conoce cómo esta herramienta está salvando familias latinas de la bancarrota médica.',
    content: `
      <p>Históricamente, el seguro de vida se veía como un gasto necesario solo para cubrir gastos funerarios. Hoy, la industria ha evolucionado, pero la información tarda en llegar a nuestra comunidad.</p>
      <p>Los beneficios en vida permiten adelantar parte del beneficio por fallecimiento si el asegurado sufre una enfermedad crítica, crónica o terminal. Esto significa que la póliza actúa como un escudo financiero mientras estás vivo, permitiéndote enfocarte en tu recuperación sin la angustia de perder tu casa o agotar tus ahorros.</p>
    `,
    author: 'Ana López',
    date: '02 Mar 2024',
    image: 'https://images.unsplash.com/photo-1573164713714-d95e436ab8d6?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
    category: 'Noticias del Movimiento'
  }
];